import { render, staticRenderFns } from "./dr-login-component.vue?vue&type=template&id=8d66daec"
import script from "./dr-login-component.vue?vue&type=script&lang=js"
export * from "./dr-login-component.vue?vue&type=script&lang=js"
import style0 from "./dr-login-component.vue?vue&type=style&index=0&id=8d66daec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports